/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorImage from 'base/components/labrador/Image';

export const DynamicLabradorImage: typeof LabradorImage = (props) => {
    return <ErrorBoundary><LabradorImage {...props} /></ErrorBoundary>;
}
export type DynamicLabradorImageProps = PropsFromComponent<typeof LabradorImage>;
